/**
 * 取引状態
 */
export type AssessmentStatus =
  | "1" // 査定
  | "2" // ユーザー承認
  | "3" // ユーザー却下


/** 査定状態：査定 */
export const Assessment = "1" as AssessmentStatus;
/** 査定状態：ユーザー承認 */
export const Approval = "2" as AssessmentStatus;
/** 査定状態：ユーザー却下 */
export const Rejection = "3" as AssessmentStatus;